/* eslint-disable */
export default {
  mute: 'Mykistä',
  unmute: 'Poista mykistys',
  hangup: 'Lopeta puhelu',
  reject: 'Hylkää',
  hold: 'Pito',
  onHold: 'Pidossa',
  transfer: 'Siirrä',
  more: 'Lisää',
  stopRecord: 'Lopeta tallentaminen',
  record: 'Tallenna',
  showKeypad: 'Näppäimistö',
  hideKeypad: 'Piilota näppäimistö',
  unHold: 'Poista pidosta',
  forward: 'Lähetä edelleen',
  ignore: 'Ohita',
  voicemail: 'Vastaajaan',
  custom: 'Mukautettu',
  answerAndEnd: 'Vastaa ja lopeta',
  answerAndHold: 'Vastaa ja aseta pitoon',
  answer: 'Vastaa',
  completeTransfer: 'Suorita siirto',
  reply: 'Vastaa',
  add: 'Lisää',
  mergeCall: 'Yhdistä käynnissä olevaan puheluun',
  endCallForEveryone: 'Lopeta puhelu kaikkien osalta',
  leaveCall: 'Poistu puhelusta',
  leaveOrEndCall: 'Poistutaanko puhelusta tai lopetetaanko se?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
